import axios from "axios"
import axiosInstance from "../../../Axios/Axios"

const addTeam=async(teamData:any)=>{
    return await axiosInstance.post('/Team/AddTeam',teamData)
    }

const getAllPersonByTenantId=async({queryKey}:any)=>{
let tenantId=queryKey[1];
return await axiosInstance.get(`/Person/GetAllPersonByTenantId?tenantId=${tenantId}&pageIndex=1&pageSize=100`)
}

const getAllStrategies=async({queryKey}:any)=>{
    let tenantId=queryKey[1];
    let periodId=queryKey[2];
    return await axiosInstance.get(`/Index/GetAllStrategies?tenantId=${tenantId}&periodId=${periodId}`)
}

const getMaxObjective=async({queryKey}:any)=>{
    let tenantId=queryKey[1];
    let periodId=queryKey[2];
    return await axiosInstance.get(`/OKR/GetMaxObjective?tenantId=${tenantId}&periodId=${periodId}`)
}

const getMaxkr=async({queryKey}:any)=>{
    let tenantId=queryKey[1];
    let periodId=queryKey[2];
    return await axiosInstance.get(`/OKR/GetMaxKeyResult?tenantId=${tenantId}&periodId=${periodId}`)
}


const getMaxbau=async({queryKey}:any)=>{
    let tenantId=queryKey[1];
    let periodId=queryKey[2];
    return await axiosInstance.get(`/OKR/GetMaxBAU?tenantId=${tenantId}&periodId=${periodId}`)
}


const getAllStrategicBAU=async({queryKey}:any)=>{
    let tenantId=queryKey[1];
    let periodId=queryKey[2];
    return await axiosInstance.get(`/Index/GetAllStrategicBAUByTenantId?tenantId=${tenantId}&periodId=${periodId}`)
}

const getAllTenantMission=async({queryKey}:any)=>{
    let tenantId=queryKey[1];
    let periodId=queryKey[2];
    return await axiosInstance.get(`/Index/GetAllTenantMission?tenantId=${tenantId}&periodId=${periodId}`)
    }

const addStrategy=async(userData:any)=>{
return axiosInstance.post('/Index/AddStrategy',userData)
}

const editStrategy=async(userData:any)=>{
    return axiosInstance.post('/Index/EditStrategy',userData)
    }

const editTenantMission=async(userData:any)=>{
    return axiosInstance.post('/Index/AddTenantMission',userData)
    }
    
    const addTenantMission=async(userData:any)=>{
        return axiosInstance.post('/Index/AddTenantMission',userData)
        }

const editPerson=async({queryKey}:any)=>{
    let perId=queryKey[1];
    let tenantId=queryKey[2];
return await axiosInstance.get(`/Person/GetPersonDetailById?id=${perId}&tenantId=${tenantId}`)
}

const getTeamDetail=async({queryKey}:any)=>{
    let teamId=queryKey[1];
    return await axiosInstance.get(`/Team/GetTeamDetailsById?id=${teamId}`)
}

const deleteInvitedPerson=(perIds:any|null)=>{
return axiosInstance.post(`/Person/DeleteInvitedPerson`,perIds)
}

const deletePerson=async(personDeletedBody:any|null)=>{
return  await  axiosInstance.post(`/Person/DeletePerson`,personDeletedBody)
}

const deleteStrategy=async(personDeletedBody:any|null)=>{
    return  await  axiosInstance.post(`/Index/DeleteStrategy`,personDeletedBody)
    }

    const deleteMission=async(personDeletedBody:any|null)=>{
        return  await  axiosInstance.post(`/Index/DeleteTenantMission`,personDeletedBody)
        }

const deleteTenant=async(teamDeletedBody:any|null)=>{
return await axiosInstance.post(`/Tenant/DeleteTenantByUser`,teamDeletedBody)
}

const deleteTeam=async(teamDeletedBody:any|null)=>{
return await axiosInstance.post(`/Team/DeleteTeam`,teamDeletedBody)
}

const editPersonStaff=async(personEditedBody:any)=>{
return await axiosInstance.post('/Person/EditPerson',personEditedBody)
}

const editTeam=async(teamEditedBody:any)=>{
    return await axiosInstance.post('/Team/EditTeam',teamEditedBody)
}

export{
    addTeam,
    getAllStrategies,
    getAllStrategicBAU,
    getAllPersonByTenantId,
    addStrategy,
    editStrategy,
    editPerson,
    deleteTeam,
    deleteTenant,
    getMaxbau,
    getMaxkr,
    deletePerson,
    editPersonStaff,
    deleteInvitedPerson,
    getTeamDetail,
    editTeam,
    getAllTenantMission,
    deleteMission,
    deleteStrategy,
    addTenantMission,
    getMaxObjective,
    editTenantMission
}